module.exports = __webpack_public_path__ + "static/media/ret-white-logo.b1bee8c6.svg";